module.exports = __webpack_public_path__ + "img/1.2d72cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/1.png
// module id = 586
// module chunks = 5